import { render, staticRenderFns } from "./ticket_owner_types.vue?vue&type=template&id=02d3f13e&scoped=true&"
import script from "./ticket_owner_types.vue?vue&type=script&lang=js&"
export * from "./ticket_owner_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d3f13e",
  null
  
)

export default component.exports